import { Button, Card, Checkbox, DatePicker, Divider, Form, Icon, Input, Popconfirm, Spin, Table, Tooltip, message } from 'antd';
import moment from 'moment';
import React from "react";
import { getFormFieldByType, sanitizeFieldName } from "../../util/methods";
import SubList from "../../components/SubList";

class Create extends React.Component {
  state = {
    rfidNo: '',
    validFrom: null,
    validTo: null,
    addingRfid: false,
    pendingRfidCards: [],
  };

  componentDidMount() {
    const { match, fetch } = this.props;
    if (match && match.params && match.params.id) {
      fetch(match.params.id);
    }
  }


  handleSubmit = (e) => {
    const { match } = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }

      if (match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
      } else {
        values.rfidCards = this.state.pendingRfidCards.map(card => ({
          rfidNo: card.rfidNo,
          validFrom: card.validFrom,
          validTo: card.validTo,
        }));
        this.props.onSubmit(values);
      }
    });
  };

  validateRfidInput = () => {
    const { rfidNo, validFrom, validTo } = this.state;

    if (!rfidNo || !rfidNo.trim()) {
      message.error('RFID Number is required');
      return false;
    }
    if (!validFrom) {
      message.error('Valid From is required');
      return false;
    }
    if (validTo && validTo.isBefore(validFrom)) {
      message.error('Valid To should be after Valid From');
      return false;
    }
    return true;
  };

  hasPendingRfidOverlap = (nextCard) => {
    return this.state.pendingRfidCards.some(card => {
      if ((card.rfidNo || '').trim().toLowerCase() !== (nextCard.rfidNo || '').trim().toLowerCase()) {
        return false;
      }
      const existingFrom = moment(card.validFrom);
      const existingTo = card.validTo ? moment(card.validTo) : moment('9999-12-31T23:59:59.999Z');
      const nextFrom = moment(nextCard.validFrom);
      const nextTo = nextCard.validTo ? moment(nextCard.validTo) : moment('9999-12-31T23:59:59.999Z');
      return existingFrom.isSameOrBefore(nextTo) && nextFrom.isSameOrBefore(existingTo);
    });
  };

  handleAddRfidCard = async () => {
    const { match, onAddRfidCard } = this.props;
    const { rfidNo, validFrom, validTo } = this.state;
    const manpowerId = match && match.params && match.params.id;

    if (!this.validateRfidInput()) {
      return;
    }

    const nextCard = {
      _id: `pending-${Date.now()}-${this.state.pendingRfidCards.length}`,
      _isPending: true,
      rfidNo: rfidNo.trim(),
      validFrom: validFrom.toISOString(),
      validTo: validTo ? validTo.toISOString() : null,
    };

    if (!manpowerId) {
      if (this.hasPendingRfidOverlap(nextCard)) {
        message.error('RFID already registered within selected period');
        return;
      }
      this.setState({
        pendingRfidCards: [...this.state.pendingRfidCards, nextCard],
        rfidNo: '',
        validFrom: null,
        validTo: null,
      });
      return;
    }

    if (!onAddRfidCard) {
      return;
    }
    this.setState({ addingRfid: true });
    try {
      await onAddRfidCard(nextCard, manpowerId);
      this.setState({
        rfidNo: '',
        validFrom: null,
        validTo: null,
      });
    } catch (e) {
      // The action already shows the API validation message.
    } finally {
      this.setState({ addingRfid: false });
    }
  };

  removePendingRfidCard = (id) => {
    this.setState({
      pendingRfidCards: this.state.pendingRfidCards.filter(card => card._id !== id),
    });
  };

  renderRfidSection = () => {
    const { data = {}, match, onRemoveRfidCard, title } = this.props;
    const manpowerId = match && match.params && match.params.id;
    const canEdit = title !== 'VIEW';
    const canShow = title === 'CREATE' || title === 'EDIT' || title === 'VIEW';

    if (!canShow) {
      return null;
    }

    const rfidCards = manpowerId
      ? (Array.isArray(data.rfidCards) ? data.rfidCards : [])
      : this.state.pendingRfidCards;
    const columns = [
      {
        title: 'RFID Number',
        dataIndex: 'rfidNo',
      },
      {
        title: 'Valid From',
        dataIndex: 'validFrom',
        render: value => value ? moment(value).format('DD-MM-YYYY HH:mm') : '',
      },
      {
        title: 'Valid To',
        dataIndex: 'validTo',
        render: value => value ? moment(value).format('DD-MM-YYYY HH:mm') : 'Active',
      },
      {
        title: 'Registered At',
        dataIndex: 'registeredAt',
        render: value => value ? moment(value).format('DD-MM-YYYY HH:mm') : '',
      },
    ];

    if (canEdit) {
      columns.push({
        title: 'Action',
        key: 'action',
        render: record => (
          <Popconfirm
            title="Remove this RFID registration?"
            onConfirm={() => record._isPending ? this.removePendingRfidCard(record._id) : onRemoveRfidCard && onRemoveRfidCard(manpowerId, record._id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="danger" size="small">Remove</Button>
          </Popconfirm>
        ),
      });
    }

    return (
      <div>
        <Divider orientation="left">RFID Cards</Divider>
        {canEdit && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', alignItems: 'flex-end', marginBottom: '16px' }}>
            <div style={{ minWidth: '220px', flex: '1 1 220px' }}>
              <label>RFID Number</label>
              <Input
                value={this.state.rfidNo}
                onChange={e => this.setState({ rfidNo: e.target.value })}
                placeholder="Enter RFID Number"
                autoComplete="off"
              />
            </div>
            <div style={{ minWidth: '220px', flex: '1 1 220px' }}>
              <label>Valid From</label>
              <DatePicker
                showTime
                value={this.state.validFrom}
                onChange={validFrom => this.setState({ validFrom })}
                style={{ width: '100%' }}
                format="DD-MM-YYYY HH:mm"
              />
            </div>
            <div style={{ minWidth: '220px', flex: '1 1 220px' }}>
              <label>Valid To</label>
              <DatePicker
                showTime
                value={this.state.validTo}
                onChange={validTo => this.setState({ validTo })}
                style={{ width: '100%' }}
                format="DD-MM-YYYY HH:mm"
              />
            </div>
            <Button
              type="primary"
              onClick={this.handleAddRfidCard}
              loading={this.state.addingRfid}
              style={{ transform: 'translateY(14px)' }}
            >
              Add RFID
            </Button>
          </div>
        )}
        <Table
          rowKey={(record, index) => record._id || index}
          dataSource={rfidCards}
          columns={columns}
          pagination={false}
          size="small"
        />
      </div>
    );
  };

  renderMobileNoFallback = () => {
    const { getFieldDecorator } = this.props.form;
    const { data = {}, filters = {}, title } = this.props;

    if (filters.mobileNo) {
      return null;
    }

    return (
      <Form.Item key="mobileNo" label="Mobile No">
        {getFieldDecorator('mobileNo', {
          initialValue: data.mobileNo || '',
        })(<Input
          placeholder="Please Enter Mobile No"
          disabled={title === 'VIEW'}
          autoComplete="off"
        />)}
      </Form.Item>
    );
  };

  renderPerformanceReminderFlag = () => {
    const { getFieldDecorator } = this.props.form;
    const { data = {}, title } = this.props;

    return (
      <Form.Item key="enablePerformanceEntryReminder" label={
        <span>Enable Performance Entry Reminder&nbsp;
          <Tooltip title="If enabled, this manpower is considered for the performance entry reminder notification">
            <Icon type="question-circle-o" />
          </Tooltip>
        </span>}>
        {getFieldDecorator('enablePerformanceEntryReminder', {
          valuePropName: 'checked',
          // records saved before this flag existed count as enabled
          initialValue: data.enablePerformanceEntryReminder !== false,
        })(<Checkbox disabled={title === 'VIEW'} />)}
      </Form.Item>
    );
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data, loading, filters, title, resource, form } = this.props;

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.props.title !== 'VIEW' ? this.handleSubmit : undefined} layout="vertical">

            {Object.keys(filters).map((item) => {
              if (item === 'rfidCards') {
                return null;
              }
              if (item === 'enablePerformanceEntryReminder') {
                return this.renderPerformanceReminderFlag();
              }
              if (filters[item].type === 'Array' && filters[item].schema) {
                return <SubList key={item} item={filters[item]} form={form} data={data[item]} title={title} resource={resource} />
              } else {
                return getFormFieldByType(filters, item, getFieldDecorator, data)
              }
            })}

            {this.renderMobileNoFallback()}

            {this.renderRfidSection()}

            {this.props.title !== 'VIEW' && (
              <Form.Item>
                <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                  {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
                </Button>
              </Form.Item>
            )}
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
